export const CUSTOMER_LOGIN_REQUIRED = "CUSTOMER_LOGIN_REQUIRED";

/**
 * The backend refused to turn an existing customer account into a professional
 * one because the visitor is not logged in as its owner. $mutate rejects with
 * the translated message (the raw code is lost), so both forms are recognized.
 */
export function isCustomerLoginRequiredError(error, i18n) {
  const key = `error.messages.${CUSTOMER_LOGIN_REQUIRED}`;
  return (
    error === CUSTOMER_LOGIN_REQUIRED || (i18n.te(key) && error === i18n.t(key))
  );
}
